import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { UIHeading } from 'app/components/ui';
import { SelectionsMobileSlider } from './MenuSelectionsMobileSlider';

import './menuSelectionsMobileSlider.scss';


const MenuSelectionsTitle = () => {
    const titleRootClasses = classNames({
        'menu-selections-title': true,
    });
    return (
        <UIHeading
            level="2.1"
            styleName={titleRootClasses}
        >
            Кое-что интересное
        </UIHeading>
    );
};


export const MenuSelectionsMobileSlider = ({ realm = 'target_realm' }) => (
    <>
        <MenuSelectionsTitle />
        <div styleName="menu-selections-slider__root">
            <div styleName="menu-selections-slider__list-container">
                <SelectionsMobileSlider realm={realm} />
            </div>
        </div>
    </>
);

MenuSelectionsMobileSlider.propTypes = {
    realm: PropTypes.string,
};
